import api from "./axios";
import {
  mapTruckHistoriesResponse,
  mapTruckHistoryResponse,
  type TruckHistory,
} from "../types/truckHistory";
import { type PaginationResponse, mapPaginationResponse } from "../types/paginationResponse";
import { type Truck, mapTruckResponse } from "../types/truck";

export interface TruckHistoryResponse {
  data: {
    history: TruckHistory[];
    pagination: {
      page: number;
      pageSize: number;
      total: number;
      totalPages: number;
      sortBy: string;
      sortOrder: string;
    };
  };
}

export interface TruckHistoryParams {
  truckId: string;
  page: number;
  pageSize: number;
}

export interface GetTruckHistoryResponse {
  history: TruckHistory[];
  pagination: PaginationResponse;
}

export const getTruckHistoryApi = async (
  params: TruckHistoryParams,
): Promise<GetTruckHistoryResponse> => {
  try {
    const url = "/api/v1/truckHistories/getByTruckId";
    const response = await api.post<any>(url, {
      truckId: params.truckId,
      page: params.page,
      pageSize: params.pageSize,
    });
    return {
      history: mapTruckHistoriesResponse(response.data),
      pagination: mapPaginationResponse(response.data.data.pagination),
    };
  } catch (error) {
    console.error("Error fetching truck history:", error);
    throw error;
  }
};

export interface AddTruckHistoryResponse {
  truckHistory: TruckHistory;
  truck: Truck;
}

export const addTruckHistoryApi = async (
  truckId: string,
  historyData: {
    location: { cityId: string };
    destination?: { cityId: string };
    status: string;
    notes?: string;
    timestamp: string;
  },
): Promise<AddTruckHistoryResponse> => {
  try {
    const url = "/api/v1/truckHistories/";
    const response = await api.post<any>(url, { ...historyData, truckId });
    return {
      truckHistory: mapTruckHistoryResponse(response.data.data.truckHistory),
      truck: mapTruckResponse(response.data.data.truck),
    };
  } catch (error) {
    console.error("Error adding truck history:", error);
    throw error;
  }
};

export const deleteTruckHistoryApi = async (
  historyId: string,
): Promise<AddTruckHistoryResponse> => {
  try {
    const url = `/api/v1/truckHistories/${historyId}/delete`;
    const response = await api.post(url);
    return {
      truckHistory: mapTruckHistoryResponse(response.data.data.truckHistory),
      truck: mapTruckResponse(response.data.data.truck),
    };
  } catch (error) {
    console.error("Error deleting truck history:", error);
    throw error;
  }
};
